import React, { useState } from "react";

const gradientDirections = {
  "to right": "to right",
  "to left": "to left",
  "to top": "to top",
  "to bottom": "to bottom",
  "to top left": "to top left",
  "to top right": "to top right",
  "to bottom left": "to bottom left",
  "to bottom right": "to bottom right",
};

const GradientGenerator = () => {
  const [via, setVia] = useState("active");
  const [direction, setDirection] = useState("to right");
  const [colorFrom, setColorFrom] = useState("#6366F1"); // Indigo-400
  const [colorVia, setColorVia] = useState("#A855F7"); // Purple-400
  const [colorTo, setColorTo] = useState("#06B6D4"); // Cyan-400

  // Generate gradient dynamically
  const gradientStyle =
    via === "active"
      ? `linear-gradient(${direction}, ${colorFrom}, ${colorVia}, ${colorTo})` // 3-color gradient
      : `linear-gradient(${direction}, ${colorFrom}, ${colorTo})`; // 2-color gradient

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
      <h1 className="text-3xl font-bold text-gray-800 mb-4">🎨 Gradient Generator</h1>

      {/* Gradient Preview */}
      <div
        className="w-96 h-48 rounded-lg shadow-lg border transition-all duration-700"
        style={{ background: gradientStyle }}
      ></div>

      {/* Controls */}
      <div className="mt-6 bg-white p-4 shadow-lg rounded-lg w-96 space-y-4">
        {/* Toggle Active/Inactive */}
        <div>
          <label className="block text-gray-600 font-medium">Gradient Type:</label>
          <select className="w-full p-2 border rounded-md" value={via} onChange={(e) => setVia(e.target.value)}>
            <option value="active">Active (3 Colors)</option>
            <option value="inactive">Inactive (2 Colors)</option>
          </select>
        </div>

        {/* Select Gradient Direction */}
        <div>
          <label className="block text-gray-600 font-medium">Gradient Direction:</label>
          <select className="w-full p-2 border rounded-md" value={direction} onChange={(e) => setDirection(e.target.value)}>
            {Object.keys(gradientDirections).map((key) => (
              <option key={key} value={gradientDirections[key]}>{key}</option>
            ))}
          </select>
        </div>

        {/* Pick Colors */}
        <div className="grid grid-cols-3 gap-4">
          <div>
            <label className="block text-gray-600 font-medium">From Color:</label>
            <input type="color" value={colorFrom} onChange={(e) => setColorFrom(e.target.value)} className="w-full cursor-pointer" />
          </div>
          {via === "active" && ( // Only show "Via Color" when via is active
            <div>
              <label className="block text-gray-600 font-medium">Via Color:</label>
              <input type="color" value={colorVia} onChange={(e) => setColorVia(e.target.value)} className="w-full cursor-pointer" />
            </div>
          )}
          <div>
            <label className="block text-gray-600 font-medium">To Color:</label>
            <input type="color" value={colorTo} onChange={(e) => setColorTo(e.target.value)} className="w-full cursor-pointer" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GradientGenerator;
